import { useGetConfigurationDeprecated } from '@ori/mobile-office-api-client-react';

import { getFullNameFormat } from './getFullNameFormat';

export interface ConsultantNameFormatters {
  getFormattedConsultantName: (firstName: string | null, lastName: string | null) => string;
  getCapitalisedInitials: (firstName: string | null, lastName: string | null) => string;
}

export const useConsultantNameFormatters = (): ConsultantNameFormatters => {
  const { data: configuration } = useGetConfigurationDeprecated();
  const fullNameFormat = getFullNameFormat(configuration);

  return {
    getFormattedConsultantName(firstName: string | null, lastName: string | null): string {
      return (
        fullNameFormat
          .replace('{FirstName}', firstName ?? '')
          .replace('{LastName}', lastName ?? '')
          // not supported formats should be cleaned
          .replace('{Greeting}', '')
          .replace('{Gender}', '')
      );
    },
    getCapitalisedInitials(firstName: string | null, lastName: string | null): string {
      return (
        fullNameFormat
          .replaceAll(' ', '')
          .replace('{FirstName}', (firstName ?? '').slice(0, 1).toUpperCase())
          .replace('{LastName}', (lastName ?? '').slice(0, 1).toUpperCase())
          // Gender or Greeting are ignored in initials
          .replace('{Greeting}', '')
          .replace('{Gender}', '')
      );
    },
  };
};
